
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.958 28.87c-1.07-1.167-2.107-1.77-2.792-2.169-.245-.142-.55-.32-.608-.397-.239-.338-2.868-4.408-4.225-6.514l-.182-.283-.327.085c-.014.003-1.386.359-2.92.88-1.27.433-3.49-.71-4.366-1.332l-.121-.085h-.15c-.233 0-1.465.166-3.702 3.182-3.211-3.39-7.681-8.31-9.824-10.69L11.246 11l-.284.681c-.018.043-.45 1.054-1.711 1.576-1.784.737-2.338 2.754-3.04 5.99C5.51 22.48.055 28.461 0 28.521l.69.625c.23-.253 5.679-6.227 6.433-9.705.723-3.332 1.228-4.808 2.485-5.329a4.37 4.37 0 00.944-.535c-.264 2.111.403 3.08 1.104 4.091.35.505.712 1.027.954 1.737.711 2.09-.332 3.036-2.06 4.606l-.331.302c-2.07 1.893-1.46 5.33-1.433 5.475l.918-.168c-.006-.03-.541-3.08 1.146-4.625l.33-.3c1.727-1.569 3.22-2.924 2.313-5.588-.283-.832-.7-1.435-1.07-1.966-.735-1.06-1.327-1.925-.791-4.327 2.436 2.698 11.56 12.762 12.942 13.703 1.513 1.03 2.703 1.495 4.35 2.138l.224.088c1.368.535 4.45 3.98 5.52 5.262l.719-.592c-.41-.491-4.059-4.815-5.898-5.534l-.223-.087c-1.65-.644-2.74-1.07-4.165-2.04-.374-.255-1.462-1.342-2.886-2.831 1.658-2.269 2.658-2.795 2.956-2.91.684.444 3.217 1.954 5.035 1.338a45.78 45.78 0 012.526-.773c.79 1.225 3.788 5.872 4.062 6.26.17.24.46.409.9.665.638.37 1.601.93 2.575 1.993 1.549 1.69 3.915 5.467 3.939 5.505l.792-.49c-.099-.158-2.435-3.887-4.042-5.64"}})])
          )
        }
      }
    